// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"416":"448fcf9a16ba69750a15","524":"4a7412019c3a71bbeccf"}[chunkId] + ".css";
};